function createFavoritesVideoCards(){
    const arr = favoritesVideosData;
    const cards = arr.map(item => 
        `<a href="${item.pageLink}" class="favorites-video-card fdc js-card" data-id='${item.id}'>
            <div class="favorites-video-card__img-wrap">
                <img src="${item.image}" alt="video poster" class="favorites-video-card__img">
                ${item.favorite ? '<span class="card__favorite js-card-icon-favorite"></span>' : ''}
            </div>
            <div class="favorites-video-card__info">
                <div>
                    ${item.trail != '' ? `<div class='fz-12-16 fw-600 c-orange'>${item.trail}</div>` : ''}
                    <div class='df fbc gap-16'>
                        <div class='fz-15-26 fw-700 c-orange'>${item.tod}</div>
                        <div class='fz-12-16 fw-600 c-gray-6'>${item.date}</div>
                    </div>
                </div>
                ${item.name != '' || item.bib != '' || item.time != ''
                    ? `<div class='h-1 bg-c-gray-2'></div>
                        <div class='df fbs gap-8 fz-12-16 fw-600'>
                            ${item.name != ''
                                ? `<div class='fw'>
                                        <div class='c-gray-6'>Name</div>
                                        <div class='c-dark'>${item.name}</div>
                                    </div>`
                                : ''
                            }
                            ${item.bib != ''
                                ? `<div class='w-22p flex-shrink-0'>
                                    <div class='c-gray-6'>BIB</div>
                                    <div class='c-dark'>${item.bib}</div>
                                </div>`
                                : ''
                            }
                            ${item.time != ''
                                ? `<div class='w-22p flex-shrink-0 ta-r'>
                                    <div class='c-gray-6'>Time</div>
                                    <div class='c-dark'>${item.time}</div>
                                </div>`
                                : ''
                            }
                        </div>`
                    : ''
                }
            </div>
            ${item.mountain !== false && item.mountain !== '' && item.mountain !== undefined
                ? `<div class='favorites-video-card__bottom fz-12-16 fw-600 mt-a'>${item.mountain}</div>`
                : ''
            } 
        </a>`
    );

    const layout = $(`.js-favorites-container-videos`).append(cards);

    $(document).trigger('favoritesVideosCardsWasCreated');

    return layout;
}

runIfElementExist(createFavoritesVideoCards, '.js-favorites-container-videos');
